module.exports = __webpack_public_path__ + "img/sign-up-girl.79d1117c.svg";